import { post, put } from './http';
import * as gtmService from "./Gtm.service";
import { klaviyoAddToCart } from './KlaviyoEvent.service';
import * as algoliaInsightsService from './AlgoliaInsights.service';

export const add = async (articleNumber, quantity = 1, fromSource = '', algoliaQueryId = '') => {
    if (!quantity || isNaN(quantity) || parseInt(quantity) <= 0) {
        throw "Invalid quantity";
    }

    const algoliaSearchQueryId = algoliaQueryId ? algoliaQueryId : algoliaInsightsService.getQueryId();
    const response = await post('/api/cart/add', { articleNumber, quantity: parseInt(quantity), algoliaSearchQueryId });
    const json = await response.json();

    // The added product
    const product = json.orderRows.find(p => p.articleNumber == articleNumber);
    if (product && product.gtmProduct) {
        product.gtmProduct.quantity = parseInt(quantity);

        gtmService.pushEcommerce({
            event: "addToCart",
            ecommerce: {
                currencyCode: gtmService.getCurrency(),
                add: {
                    products: [product.gtmProduct]
                }
            }
        });
        algoliaInsightsService.addToCart(product.gtmProduct, fromSource, algoliaSearchQueryId);
        try {
            klaviyoAddToCart(json.orderRows, product, quantity);
        } catch (ex) {
            console.warn(ex);
        }
    }

    return json;
};

export const reorder = async (orderId) => {
    const response = await post('/api/cart/reorder', { orderId });
    return response.json();
};

export const updateQuantity = async (rowSystemId, quantity, abortController) => {
    const productToChange = window.__litium.store.getState().cart.orderRows.find(r => r.rowSystemId == rowSystemId);
    const res = await put(`/api/cart/update`, { rowSystemId, quantity }, abortController);
    const cart = await res.json();

    let decreaseQuantity = quantity - productToChange.quantity <= 0;

    productToChange.gtmProduct.quantity = Math.abs(quantity);

    let addRemoveObj = {};

    addRemoveObj[decreaseQuantity ? "remove" : "add"] = {
        products: [productToChange.gtmProduct]
    };

    gtmService.pushEcommerce({
        event: decreaseQuantity ? "removeFromCart" : "addToCart",
        ecommerce: {
            currencyCode: gtmService.getCurrency(),
            ...addRemoveObj
        }
    });

    return cart;
};